export default "__VITE_ASSET__CTwrQJjz__"